export * from "-!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./LoginPage.vue?vue&type=template&id=00cf7be6&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/pages/LoginPage.vue?vue&type=template&id=00cf7be6&scoped=true&
// module id = 560
// module chunks = 1